export enum LinuxServiceAction {
    Start = 'start',
    Stop = 'stop',
    Restart = 'restart',
    Refresh = 'refresh',
}
